export default import.meta.ROLLDOWN_FILE_URL_VviROhWIdWGBwh5zbtT9rA